import React, { Component } from 'react';
import { Autocomplete, Box, Button, Checkbox, Drawer, FormControlLabel, IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import '../reports.css';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import { CommonGridToolBarWithFilterText, CommonPatientDetails } from "../../../../Components/Common Components/CommonComponents";
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { splitDate, AmountFormat, formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards';
import Loader from '../../../../Components/Loader';
import { CurrencySymbol } from '../../../../Utility/Constants';

const deptList = [
    { label: "IP", value: "ip" },
    { label: "OP", value: "op" },
]
if(localGetItem("Show_Radiology_Bills_In_FO") === "true"){
    deptList.push( { label: "Radiology", value: "radiology" })
}

let LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))

if (localGetItem("multiLaboratory") === "true") {
    LoggedUserData?.laboratory_data?.map((item) => {
        deptList.push({ label: item?.laboratory_name, value: item?.laboratory_name })
    })
} else {
    deptList.push({ label: "Lab", value: "lab" })
}

const concessionList = ["Doctor", "Hospital"];
class ConcessionReport extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            dateIndex: 1,
            concessionData: [],
            department: [],
            doctorNameList: localGetItem("DoctorsList") === null ? [] : JSON.parse(localGetItem("DoctorsList")),
            doctorName: null,
            billNumber: "",
            total_bill_amount: 0,
            total_concession: 0,
            concession_type: "",
            total_doctor_concession: 0,
            total_hospital_concession: 0,
            opSelected : true,
            ipSelected : true,
            labSelected : true,
            radiologySelected :(localGetItem("Show_Radiology_Bills_In_FO") === "true") ? true : false ,
            patient_name : "",
            uhid : "",
            printLoading: false,
            disableBtn: false,
        }
    }

    componentDidMount() {
        let LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))
        let labDetails = JSON.parse(JSON.stringify((LoggedUserData?.laboratory_data)))
        labDetails?.forEach((item) => (
            item["isChecked"] = true
        ))
        this.setState({
            LabData: labDetails
        }, () => {
            this.getConcessionData()
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }

    FilterDate = (from, to, index) => {
        this.setState({
            fromDate: from,
            toDate: to,
            dateIndex: index
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }
    handleCheckBox = (e, data) => {
        let states = this.state
        data["isChecked"] = e.target.checked
        this.setState({ states })
    }

    getConcessionData = () => {
        let doctor_id = this.state.doctorName ? this.state.doctorName.doctor_id : "";
        let LabId = this.state.LabData?.map((item)=> item?.laboratory_id)
        let doctor_name = this.state.doctorName ? this.state.doctorName.doctor_name : "";

        let concession_type = this.state.concession_type ? this.state.concession_type : "";
        try {
            let moduleType = []
            if (this.state.opSelected) {
                moduleType?.push("op")
            }
            if (this.state.ipSelected) {
                moduleType?.push("ip")
            }
            if (this.state.radiologySelected) {
                moduleType?.push("radiology")
            }
            if (localGetItem("multiLaboratory") === "true") {
                let selectedLab = this.state.LabData?.filter((item) => item?.isChecked);
                LabId = selectedLab?.length > 0 ? selectedLab?.map((item) => item?.laboratory_id) : ""
                if (LabId !== "") {
                    moduleType.push("lab")
                }
            }
            else {
                if (this.state.labSelected) {
                    moduleType?.push("lab")

                } else {
                    LabId = ''
                }
            }
            this.LoaderFunction(true);
            const baseUrl = localGetItem("isNewBilling") === "true" ? Serviceurls.NEW_CONSSESION_REPORT : Serviceurls.FO_REPORTS_CONCESSION;
            RestAPIService.getAll(`${baseUrl}?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&department=${moduleType}&doctor_id=${doctor_id}&bill_no=${this.state.billNumber}&concession_type=${concession_type}&laboratory_id=${LabId}&doctor_name=${doctor_name}&patient_name=${this.state.patient_name}&uhid=${this.state.uhid ? this.state.uhid :""}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.LoaderFunction(false);
                        let list = response.data?.data?.length > 0 ? response.data?.data : [];
                        list.forEach((item, index) => {
                            item["concession_amount"] = item.doctor_concession ? item.doctor_concession : item.hosptial_concession;
                            item["sno"] = index + 1
                        })
                        this.setState({
                            concessionData: list,
                            total_bill_amount: response?.data?.total_bill_amount,
                            total_concession: response?.data?.total_concession_amount,
                            total_doctor_concession: response?.data?.total_doctor_concession,
                            total_hospital_concession: response?.data?.total_hospital_concession,
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.LoaderFunction(false);
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.LoaderFunction(false);
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    printReports = () => {
        try {
            let  LabId= this.state.LabData?.map((item)=> item?.laboratory_id)
            let moduleType = []
            if (this.state.opSelected) {
                moduleType?.push("op")
            }
            if (this.state.ipSelected) {
                moduleType?.push("ip")
            }
            if (this.state.radiologySelected) {
                moduleType?.push("radiology")
            }
            if (localGetItem("multiLaboratory") === "true") {
                let selectedLab = this.state.LabData?.filter((item) => item?.isChecked);
                LabId = selectedLab?.length > 0 ? selectedLab?.map((item) => item?.laboratory_id) : ""
                if (LabId !== "") {
                    moduleType?.push("lab")
                }
            }
            else {
                if (this.state.labSelected) {
                    moduleType?.push("lab")

                } else {
                    LabId = ''
                }
            }

            let doctor_id = this.state.doctorName ? this.state.doctorName.doctor_id : "";
            let concession_type = this.state.concession_type ? this.state.concession_type : "";
            let doctor_name = this.state.doctorName ? this.state.doctorName.doctor_name : "";
            const baseUrl = localGetItem("isNewBilling") === "true" ? Serviceurls.NEW_CONSSESION_REPORT : Serviceurls.FO_REPORTS_CONCESSION;
            RestAPIService.getAll(`${baseUrl}?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&department=${moduleType}&doctor_id=${doctor_id}&doctor_name=${doctor_name}&bill_no=${this.state.billNumber}&concession_type=${concession_type}&laboratory_id=${LabId}&patient_name=${this.state.patient_name}&uhid=${this.state.uhid ? this.state.uhid :""}&export_type=pdf`)
                .then((response) => {
                    if (response) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                        window.open(fileURL);
                        this.setState({disableBtn: false, printLoading: false})
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                    this.setState({disableBtn: false, printLoading: false})
                })
        } catch (error) {
            this.errorMessage(error.message)
            this.setState({disableBtn: false, printLoading: false})
        }
    }
   
    concesssionReportExportData = () => {
        try {
            let LabId = this.state.LabData?.map((item) => item?.laboratory_id)
            let moduleType = []
            if (this.state.opSelected) {
                moduleType?.push("op")
            }
            if (this.state.ipSelected) {
                moduleType?.push("ip")
            }
            if (this.state.radiologySelected) {
                moduleType?.push("radiology")
            }
            if (localGetItem("multiLaboratory") === "true") {
                let selectedLab = this.state.LabData?.filter((item) => item?.isChecked);
                LabId = selectedLab?.length > 0 ? selectedLab?.map((item) => item?.laboratory_id) : ""
                if (LabId !== "") {
                    moduleType?.push("lab")
                }
            }
            else {
                if (this.state.labSelected) {
                    moduleType?.push("lab")
                } else {
                    LabId = ''
                }
            }
            let doctor_id = this.state.doctorName ? this.state.doctorName.doctor_id : "";
            let concession_type = this.state.concession_type ? this.state.concession_type : "";
            let doctor_name = this.state.doctorName ? this.state.doctorName.doctor_name : "";
            const baseUrl = localGetItem("isNewBilling") === "true" ? Serviceurls.NEW_CONSSESION_REPORT : Serviceurls.FO_REPORTS_CONCESSION;
            RestAPIService.excelGet(`${baseUrl}?from_date=${this.state.fromDate}&to_date=${this.state.toDate}&department=${moduleType}&doctor_id=${doctor_id}&doctor_name=${doctor_name}&bill_no=${this.state.billNumber}&concession_type=${concession_type}&laboratory_id=${LabId}&patient_name=${this.state.patient_name}&uhid=${this.state.uhid ? this.state.uhid : ""}&export_type=excel`)
                .then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response?.data; //here we load our csv data 

                        let filename = response?.headers["content-disposition"]?.split("filename=")[1]

                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                        this.setState({ disableBtn: false })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === "fail") {
                        this.errorMessage(error?.response?.data?.message)
                    } else {
                        this.errorMessage(error?.message)
                    }
                    this.setState({ disableBtn: false })
                })
        } catch (e) {
            this.errorMessage(e?.message)
            this.setState({ disableBtn: false })
        }
    }

    renderFilterScreen = () => {
        const { t } = this.props
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button emed_tid={'filter_btn'} onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle' overflow={'auto'}>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={this.state.fromDate}
                            ToDate={this.state.toDate}
                            emed_tid = {"FilterDate_TestID01"} 
                            DateIndex={this.state.dateIndex}
                            SelectedDates={this.FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    {/* <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            multiple
                            limitTags={1}
                            size='small'
                            disableClearable
                            options={deptList}
                            getOptionLabel={(option) => (typeof(option.label) === "string" ? option.label : option)}
                            value={this.state.department}
                            onChange={(event, newValue) => {
                                this.setState({ department: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    inputProps={{ ...params.inputProps,'emed_tid': 'select_department' }}
                                    label={t("Select Department")}
                                    autoComplete='off'
                                    emed_tid = {"FDepartment_TestID01"} 
                                />
                            )}
                        />
                    </Box> */}
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            // disableClearable
                            options={concessionList}
                            getOptionLabel={(option) => (option)}
                            value={this.state.concession_type}
                            onChange={(event, newValue) => {
                                this.setState({ concession_type: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    inputProps={{ ...params.inputProps,'emed_tid': 'concession_type' }}
                                    label={t('Select Concession Type')}
                                    autoComplete='off'
                                    emed_tid = {"Concession_TestID01"} 
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            // disableClearable
                            options={this.state.doctorNameList?.map((item) => item)}
                            getOptionLabel={(option) => (option?.doctor_name)}
                            value={this.state.doctorName}
                            onChange={(event, newValue) => {
                                this.setState({ doctorName: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    inputProps={{ ...params.inputProps,'emed_tid': 'select_docter' }}
                                    label={t('selectDoctor')}
                                    autoComplete='off'
                                    emed_tid = {"selectDoctorTestID01"} 
                                />
                            )}
                            renderOption={(props, option) => (
                                <li {...props} key={option?.doctor_id}>
                                  {option?.doctor_name}
                                </li>
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{width: "20vw"}}
                            inputProps={{ maxLength: 6 , emed_tid: 'billnumber'}}
                            size='small'
                            label={t("BillNumber")}
                            value={this.state.billNumber}
                            autoComplete='off'
                            emed_tid = {"BillNumberTestID01"} 
                            onChange={(e) => {
                                let number = CommonValidation.numberOnly(e.target.value);
                                if (number || e.target.value === "") {
                                    this.setState({ billNumber: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{width: "20vw"}}
                            inputProps={{ maxLength: 20 , emed_tid: 'patient_name'}}
                            size='small'
                            label={t("Patient Name")}
                            value={this.state.patient_name}
                            autoComplete='off'
                            emed_tid = {"patient_nameTestID01"} 
                            onChange={(e) => {
                                let alpha = CommonValidation.alphabetOnly(e.target.value);
                                if (alpha || e.target.value === "") {
                                    this.setState({ patient_name: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{width: "20vw"}}
                            inputProps={{ maxLength: 20 , emed_tid: 'UHID'}}
                            size='small'
                            label={t("UHID")}
                            value={this.state.uhid ? this.state.uhid :""}
                            autoComplete='off'
                            emed_tid = {"UHIDTestID01"} 
                            onChange={(e) => {
                                let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                if (number || e.target.value === "") {
                                    this.setState({ uhid: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box component={"div"}>
                        <Box className="eMed_Filter_Header">
                            <Typography marginLeft={"1vw"} >Select Department</Typography>
                        </Box>
                        <Box className="eMed_CheckBox_Group">   
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.opSelected} onChange={(e) => { this.setState({ opSelected: e.target.checked }) }} size='small' />} label={t("Out Patient")} />
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.ipSelected} onChange={(e) => { this.setState({ ipSelected: e.target.checked }) }} size='small' />} label={t("In Patient")} />
                            {localGetItem('multiLaboratory') === "true" ?
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    {this.state.LabData?.map((item, i) => (
                                        <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={item?.isChecked} onChange={(e) => { this.handleCheckBox(e, item) }} size='small' />} label={item?.laboratory_name} />
                                    ))}
                                </Box>
                                : <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.labSelected} onChange={(e) => { this.setState({ labSelected: e.target.checked }) }} size='small' />} label={t("Lab")} />
                            }   
                            <FormControlLabel disabled={localGetItem("Show_Radiology_Bills_In_FO") !== "true"} className='eMed_CheckBoxDiv' control={<Checkbox checked={this.state.radiologySelected} onChange={(e) => { this.setState({ radiologySelected: e.target.checked }) }} size='small' />} label={t("Radiology")} />
                        </Box>
                    </Box>

                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"  emed_tid = {"getConcessionDataTestID01"} 
                        onClick={() => {
                            if (localGetItem("multiLaboratory") === "true") {
                                this.state.LabData?.forEach((item) => (item["isChecked"] = true))
                            }
                            this.setState({
                                billNumber: "",
                                department: [],
                                patient_name :"",
                                uhid :"",
                                doctorName: null,
                                concession_type: "",
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                opSelected : true,
                                ipSelected : true,
                                labSelected : true,
                                radiologySelected : (localGetItem("Show_Radiology_Bills_In_FO") === "true") ? true : false,
                            }, () => this.getConcessionData())
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small" emed_tid = {"Search_TestID01"} 
                        onClick={() => {
                            this.getConcessionData()
                            this.setState({
                                FilterOpen: false
                            })
                        }}
                        id="eMed_Config_btn"  >{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(this.state.fromDate) },
            { label: "To Date", value: formatDate(this.state.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
            </Box>

        )
    }

    render() {
        const { t } = this.props
        let {concessionData} = this.state;
        const columns = [
            {
                field: "patient_name", headerName: t("Patient Details"), flex: 0.16, density: 'compact',
                renderCell: ({ row }) => (<CommonPatientDetails data={row} disablePhoto={true} />), valueGetter: (params) => {
                    const name = params.row?.patient_name || "";
                    const mobile = params.row?.patient_mobile_number || "";
                    const UHID = params.row?.patient_uhid || "";
                    return `${name} ${mobile} ${UHID}`;
                }
            },
            {
                field: "doctor_name", headerName: t("Doctor Name"), flex: 0.13, density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.doctor_name?.length > 20 ?
                    <Tooltip placement='top' title={row?.doctor_name} arrow><div>{row?.doctor_name.slice(0, 18) + "..."}</div></Tooltip>
                    : row?.doctor_name ? row?.doctor_name : "-"}</Box>)
            },
            {
                field: "department", headerName: t("Department"), flex: 0.10, density: 'compact',
                renderCell: ({ row }) => (
                    <Box component={'div'}>
                        <Typography fontSize={'0.9vw'} >{row?.department ? row?.department : '-'}</Typography>
                        {row?.patient_type ? <Typography fontSize={'0.8vw'}>{row?.patient_type}</Typography> : null}
                    </Box>
                )
            },
            {
                field: "concession_type", headerName: t("Concession Type"), flex: 0.10, density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.concession_type?.length > 15 ?
                    <Tooltip placement='top' title={row?.concession_type} arrow><div>{row?.concession_type.slice(0, 13) + "..."}</div></Tooltip>
                    : row?.concession_type ? row?.concession_type : "-"}</Box>)
            },
            {
                field: "invoice_number", headerName: t("Bill No"), flex: 0.09, align: "center", headerAlign: "center", density: 'compact',
                renderCell: ({ row }) => {
                    let BillNumber = row?.common_invoice_number ? row?.common_invoice_number : row?.invoice_number ? row?.invoice_number : ""
                    return (
                        <Tooltip placement='top' title={BillNumber} arrow>
                            <Box component={'div'}>{BillNumber ? '...' + BillNumber?.slice(-10) : "-"}</Box>
                        </Tooltip>
                    )
                }
            },
            {
                field: "invoice_date", headerName: t("Bill Date"), flex: 0.10, align: "center", headerAlign: "center", density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.invoice_date ? splitDate(row?.invoice_date) : "-"}</Box>)
            },
            {
                field: "common_total_amount", headerName: t("Bill Amount"), flex: 0.10, type: "number", density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.common_total_amount ? AmountFormat(row?.common_total_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            {
                field: "concession_amount", headerName: t("Concession"), flex: 0.10, type: "number", density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.concession_amount ? AmountFormat(row?.concession_amount).replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            {
                field: "remarks", headerName: t("Remarks"), flex: 0.11, density: 'compact',
                renderCell: ({ row }) => (<Box component={'div'}>{row?.remarks?.length > 13 ?
                    <Tooltip placement='top' title={row?.remarks} arrow><div>{row?.remarks.slice(0, 13) + "..."}</div></Tooltip>
                    : row?.remarks ? row?.remarks : "-"}</Box>)
            }
        ]
        return (
            <Box component={'div'} className='eMed_rts_container'>
                <Box component={"div"} className='eMed_Top_Container'>
                    <Box component={"div"} className='eMed_Cards_Container'>
                    {/* {AmountsCard(t("Total Bill Amount"), this.state.total_bill_amount)} */}
                    {AmountsCard(t("Total Doctor concession"), this.state.total_doctor_concession)}
                    {AmountsCard(t("Total Hospital concession"), this.state.total_hospital_concession)}
                    {AmountsCard(t("Total Concession"), this.state.total_concession)}

                    </Box>
                    <Box component={"div"} className='eMed_Action_Container'>
                        <Box component={"div"} className='eMed_Filter_Icon_div'>
                            <Button className='eMed_usrconf_btn'  sx={{ml:"1vw"}} emed_tid = {"eMed_action_img_TestID"} onClick={() => { this.setState({ FilterOpen: true }) }}>
                                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                            </Button>
                        </Box>
                        <Tooltip title={t("Print")} placement='top' arrow>
                            <Button className='eMed_usrconf_btn'   emed_tid = {"eMed_usrconf_btn_TestID01"} disabled={this.state.disableBtn} onClick={() => { this.printReports() }}>
                                <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                            </Button>
                        </Tooltip>
                        <Tooltip title={t("Excel")} placement='top' arrow>
                            <IconButton className='eMed_usrconf_btn'  emed_tid="excel_btn_testID"  onClick={() => { this.concesssionReportExportData() }}>
                                <img src={ImagePaths.LabUploadButton.default} alt="upload" className='eMed_action_img' />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_rts_table'>
                    <DataGrid
                        rows={concessionData}
                        columns={columns}
                        getRowId={(row) => row.sno}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        disableSelectionOnClick
                    />
                </Box>
                <Drawer
                    anchor={'right'}
                    open={this.state.FilterOpen}
                    ModalProps={{ onBackdropClick: this.closeFilter }}
                >
                    {this.renderFilterScreen()}
                </Drawer>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                <Loader loaderOpen={this.state.isLoader || this.state.printLoading} forPrint={this.state.printLoading ? true : false} label={this.state.printLoading ? "Building PDF..." : null} />
            </Box>
        )
    }
    closeFilter = () => {
        this.setState({ FilterOpen: false })
    }
}


export default withTranslation()(ConcessionReport)